import { FC, useEffect, useState } from 'react';
import {
  useBreadcrumbRoutes,
  Wrapper,
  Form,
  FormTitle,
  Switch,
  Radio,
  Button,
  Modal,
  message,
} from '@maxtropy/components';

import { InfoCircleOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { apiV2CacheGetPost, apiV2CacheSavePost } from '@maxtropy/cc-customer-apis-v2';

const AccountSecurity: FC = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [form] = Form.useForm();
  const accountLimit = Form.useWatch('accountLimit', form);

  useEffect(() => {
    apiV2CacheGetPost({ cacheKey: 'AccountSecurity' }).then(res => {
      if (res.cacheValue) {
        const data = JSON.parse(res.cacheValue);
        form.setFieldsValue({
          ...data,
        });
      }
    });
  }, []);

  const apply = () => {
    let seconds = 3;
    const modal = Modal.confirm({
      title: '确认应用账号安全配置',
      content: `执行相关配置后将会应用到平台内所有用户账号，是否确定？`,
      okText: `确定(${seconds}秒)`,
      okButtonProps: {
        disabled: true,
      },
      onOk: () => {
        apiV2CacheSavePost({ cacheKey: 'AccountSecurity', cacheValue: JSON.stringify(form.getFieldsValue()) }).then(
          res => {
            setIsEdit(false);
            message.success('应用成功');
          }
        );
      },
    });

    const interval = setInterval(() => {
      seconds -= 1;
      modal.update({
        okText: `确定(${seconds}s)`,
      });
      if (seconds <= 0) {
        clearInterval(interval);
        modal.update({
          okText: '确定',
          okButtonProps: { disabled: false },
        });
      }
    }, 1000);
  };

  return (
    <Wrapper routes={breadcrumbRoutes?.routes} className="page_wrapper">
      <FormTitle title="账号安全设定" />
      <div style={{ marginLeft: 32 }}>
        <Form form={form} disabled={!isEdit}>
          <Form.Item label="账号口令错误限制" name="accountLimit" valuePropName="checked">
            <Switch onChange={() => {}} />
          </Form.Item>
          {accountLimit && (
            <>
              <Form.Item label="口令错误限制次数" name="numberLimit">
                <Radio.Group buttonStyle="solid">
                  <Radio.Button value="number5">5次</Radio.Button>
                  <Radio.Button value="number10">10次</Radio.Button>
                  <Radio.Button value="number30">30次</Radio.Button>
                  <Radio.Button value="number60">60次</Radio.Button>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="判断时长范围">
                <Form.Item name="durationRange" noStyle>
                  <Radio.Group buttonStyle="solid">
                    <Radio.Button value="range1">1分钟</Radio.Button>
                    <Radio.Button value="range5">5分钟</Radio.Button>
                    <Radio.Button value="range10">10分钟</Radio.Button>
                    <Radio.Button value="range15">15分钟</Radio.Button>
                    <Radio.Button value="range30">30分钟</Radio.Button>
                    <Radio.Button value="range60">60分钟</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <div style={{ color: 'var(--mx-text-desc-color)', marginTop: 8 }}>
                  <InfoCircleOutlined style={{ color: 'var(--mx-warning-color)', marginRight: 4 }} />
                  在上述限定的时长范围内，输入口令错误达到对应的限制次数，将冻结用户账号，相关应用将在全平台生效，请慎用此设置
                </div>
              </Form.Item>
              <Form.Item label="锁定时长">
                <Form.Item name="lockDuration" noStyle>
                  <Radio.Group buttonStyle="solid">
                    <Radio.Button value="lock5">5分钟</Radio.Button>
                    <Radio.Button value="lock10">10分钟</Radio.Button>
                    <Radio.Button value="lock15">15分钟</Radio.Button>
                    <Radio.Button value="lock30">30分钟</Radio.Button>
                    <Radio.Button value="lock60">60分钟</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <div style={{ color: 'var(--mx-text-desc-color)', marginTop: 8 }}>
                  <InfoCircleOutlined style={{ color: 'var(--mx-warning-color)', marginRight: 4 }} />
                  在限定时长范围内，输入口令错误达到一定限制的情况下，将按配置的锁定时长冻结用户账号，相关应用将在全平台生效，请慎用此设置。
                </div>
              </Form.Item>
            </>
          )}
        </Form>
        <div style={{ marginTop: 32 }}>
          {isEdit ? (
            <Space>
              <Button type="primary" onClick={apply}>
                应用
              </Button>
              <Button onClick={() => setIsEdit(false)}>取消</Button>
            </Space>
          ) : (
            <Button type="primary" onClick={() => setIsEdit(true)}>
              编辑
            </Button>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default AccountSecurity;
